/** J7: a small "ไป" button that sends navTo (systems/nav.ts); pressed again it stops the walk. */
import type { NavTarget, PlayerCommand } from '@nine/shared';
import { h } from './dom';

export type Send = (c: PlayerCommand) => void;

export function goButton(send: Send | undefined, target: NavTarget, title = 'นำทางไป'): HTMLButtonElement {
  const b = h('button', { type: 'button', class: 'go-btn', title }, 'ไป') as HTMLButtonElement;
  b.style.cssText =
    'margin-left:8px;padding:0 8px;font:inherit;font-size:12px;line-height:18px;border-radius:3px;cursor:pointer;' +
    'border:1px solid rgba(236,190,84,.75);background:rgba(40,20,10,.55);color:#ffe6a0';
  b.addEventListener('pointerdown', (e) => e.stopPropagation());
  b.addEventListener('click', (e) => {
    e.stopPropagation();
    send?.({ t: 'navTo', target });
  });
  return b;
}
